import { forwardRef, useId, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { LabeledField } from "./LabeledField";

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  etiqueta: string;
  error?: string | null;
  ayuda?: string;
  contenedorClassName?: string;
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(function TextField(
  { etiqueta, error, ayuda, id, className, contenedorClassName, ...props },
  ref,
) {
  const idAuto = useId();
  const idInput = id ?? idAuto;
  const descripcion = error ? `${idInput}-error` : ayuda ? `${idInput}-ayuda` : undefined;
  return (
    <LabeledField etiqueta={etiqueta} htmlFor={idInput} error={error} ayuda={ayuda} className={contenedorClassName}>
      <input
        ref={ref}
        id={idInput}
        aria-invalid={error ? true : undefined}
        aria-describedby={descripcion}
        className={cn(
          "h-11 w-full rounded-control border border-borde-fuerte bg-superficie px-3 text-texto",
          "placeholder:text-texto-suave/70 focus:border-primario focus:outline-none focus:ring-2 focus:ring-primario/25",
          "disabled:bg-superficie-2 disabled:text-texto-suave",
          error && "border-peligro focus:border-peligro focus:ring-peligro/25",
          className,
        )}
        {...props}
      />
    </LabeledField>
  );
});
